import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const upsertRoleSalary = async (data) => {
  const res = await axiosInstance.post("/api/payroll-portal/role-salary", data);
  return res.data;
};

export const getAllRoleSalaries = async () => {
  const res = await axiosInstance.get("/api/payroll-portal/role-salary");
  return res.data;
};

export const getRoleSalaryByRole = async (roleId) => {
  const res = await axiosInstance.get(`/api/payroll-portal/role-salary/role/${roleId}`);
  return res.data;
};

export const deleteRoleSalary = async (id) => {
  const res = await axiosInstance.delete(`/api/payroll-portal/role-salary/${id}`);
  return res.data;
};
